export const SM = '320px';

export const MD = '768px';

export const LG = '1024px';

export const XL = '1440px';

const BasicBreakpoint = {
    SM,
    MD,
    LG,
    XL,
};

export default BasicBreakpoint;
